//extracted by mini-css-extract-plugin
export default {"calendarIcon":"styles_calendarIcon__2sX2S","activityCompleteDateText":"styles_activityCompleteDateText__-B1Cs"};;